<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          
          @click="getList"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px"
          @click="select()"
          >筛选</el-button
        >
          <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background:#06CC00;border:1px solid #06CC00;margin-bottom: 5px;font-size: 12px;"
        @click="checkSuccessList(2)"
        >批量发送</el-button
      >
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="margin: 0 10px;">用户</label>
          <el-input
            v-model="uid"
            placeholder="请输入用户"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 1051px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
       <el-table-column type="selection" width="50" :selectable="checkSelectable"/>
       <el-table-column prop="address" label="状态" width="130">
          <template slot-scope="scoped">
            <div style="display: flex;align-items: center;justify-content: center;color:#999" v-if="scoped.row.receiveStatus == 0">
                未领取
            </div> 
            <div style="display: flex;align-items: center;justify-content: center;color: #06CC00;" v-if="scoped.row.receiveStatus == 1">
                已领取
            </div>
            <div style="display: flex;align-items: center;justify-content: center;" v-if="scoped.row.receiveStatus == 0">
                <el-button type="success" size="mini" @click="checkSuccessList(1,scoped.row)">发送奖金</el-button>
            </div>
          </template>
        </el-table-column> 
        <el-table-column prop="receiveAmount" label="领取奖励金额" width="110" />
        <el-table-column prop="lastUploadDate" label="周期" width="150">
            <template slot-scope="scoped">
                <div  v-if="scoped.row.date1"> {{ happenTimeFun(scoped.row.date1) }} ~  {{ happenTimeFun(scoped.row.date2) }}
             </div>
          </template>
        </el-table-column>
        <el-table-column prop="memberUid" label="用户" width="100" />
        <el-table-column prop="address" label="今日打卡次数" width="120">
          <template slot-scope="scoped">
            <div>{{ scoped.row.todayCheckCount }}/{{ scoped.row.maxCheckDay }}</div> 
          </template>
        </el-table-column> 
        <el-table-column prop="address" label="本周打卡次数" width="120">
          <template slot-scope="scoped">
            <div>{{ scoped.row.checkCount }}/{{ scoped.row.maxCheckWeek }}</div> 
          </template>
        </el-table-column> 
        <el-table-column prop="address" label="打卡结果" width="100">
          <template slot-scope="scoped">
            <div v-if="scoped.row.checkResult == 0">未完成</div> 
            <div v-if="scoped.row.checkResult == 1" style="color: #06CC00;">已完成</div> 
          </template>
        </el-table-column> 

        <el-table-column prop="createDate" label="创建时间" width="170" />
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
      <el-dialog
      :visible.sync="edit_dialogVisible"
      width="500px"
      title="上传历史"
      :center="true"
      :close-on-click-modal="false"
      @close="closeIsEnabled()"
    >
      <!-- 编辑用户表格 -->
      <div>
        <div v-for='(item,index) in historyList' :key='index'>
          <div style="display: flex;align-items: center;">{{item.createDate }} <span v-if='item.status == 2' style="color: red;margin-left: 5px;">已拒绝</span> </div>
          <div style="display: flex;flex-wrap: wrap;margin: 10px 0;">
                <el-image style="height: 60px;margin-left: 10px;max-width: 50px;" v-for="(itm,ind) in item.images" :key="ind" :src="itm" fit="fill" :preview-src-list="item.images" @click.stop="handleClickItem"/>
            </div>
        </div>
      </div>
    </el-dialog>
    </div>
  </template>
  
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
  import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
  export default {
    name: "Management",
    components: { Pagination,VueUeditorWrap,UploadImage },
    data() {
      return {
        option: "", // 初始选项
        options: [], // 选择角色
        name: "", // 搜索的管理员名称
        tableData: [], // 展示的表单信息
        // 添加表单
        active: {},
        // 修改表单
        editForm: { },
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        historyList: [], // 选中项s
        yiFangDetailList: [], // 
        dialogVisible: false, // 添加弹窗
        dialog: false, // 添加弹窗
        edit_dialogVisible: false, // 编辑弹窗
        Isedit: false, // 是否是编辑弹窗
        loading: false, // 表格加
        buttongLoding: false, // 按钮加载
        sn:'',
        lang:'en',
        isEnabled:false,
        isChat:false,
        isTelegram:false,
        isWhatsApp:false,
        isMessenger:false,
        isLinkUrl:false,
        isTelegramGroup:false,
        dialogVisibleUpdate:false,
        dataTime:['',''],
        yifangId:'',
        status:'',
        status2:'',
        ipCount:'',
        c1:'',
        uid:'',
        stage:'',
        round:'',
        ipCc:'',
        lastIpAddress:'',
        platformMemo:"",
        num:0
        
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
    getChildrenSum(row) {
      this.historyList = row;
      this.edit_dialogVisible = true
    },
    previewImg(list){
      let list1 = []
      list.forEach(item => {
        list1.push(item+'?x-oss-process=image/resize,w_450')
      })
      return list1
  
    },
      handleClickItem() {
        this.$nextTick(() => {
          // 获取遮罩层dom
          const domImageMask = document.querySelector('.el-image-viewer__mask')
          if (!domImageMask) {
            return
          }
          domImageMask.addEventListener('click', () => {
            // 点击遮罩层时调用关闭按钮的 click 事件
            document.querySelector('.el-image-viewer__close').click()
          })
        })
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
    approveStatus1and(){
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
            return this.$message.info("你并没有选中任何选项");
          }
      this.$confirm("是否批量审核通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = []; 
        this.multipleSelection.forEach((item) => {
        ids.push({
          id:item.id,
          receiveType1:item.receiveType1,
          receiveType2:item.receiveType2
        });
      });
      var params = ids;
      console.log(params)
      this.$api.operate
        .approveStatus1and(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      })
    },
      // 批量审核通过
    checkSuccessList(type,row){
        if(type == 1){
            var ids = [row.id];
            var params = {
               ids: ids.toString(),
            };
      this.$api.operate
        .memberSubsidyZhuan(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
  
        }
        if(type == 2){
          if (!this.multipleSelection || this.multipleSelection.length < 1) {
            return this.$message.info("你并没有选中任何选项");
          }
      this.$confirm("是否批量审核通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .memberSubsidyZhuan(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      })
  
        }
    },
    checkSelectable(row) {
        if(row.receiveStatus == 0){
            return true
        }else{
            return false
        }
    },
    approveStage4(row){
      var params = {
        receiveType1: row.receiveType1,
        receiveType2: row.receiveType2,
        ids: row.id
      };
      this.$api.operate 
        .approveStage(params)
        .then((res) => { 
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        }); 
    },
    checkRejectList(type,row){
        if(type == 1){
            var ids = [row.id];
            var params = {
               ids: ids.toString(),
            };
      this.$api.operate
        .rejectList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
  
        }
      if(type == 2){
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核拒绝?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .rejectList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      }).catch(() => {
        
        });
      }
    },
    selectOrder(name, type) {
      this.myAmount = "";
      this.c1 = "";
      this.inviteCount = "";
      if (name == "IP数量") {
        this.ipCount = type;
      }
      if (name == "下级数量") {
        this.c1 = type;
      }
  
      this.pageNum = 1;
      this.getList();
    },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          memberUid:this.uid
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
          this.$api.operate
          .memberSubsidyList(params)
          .then((res) => {
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 关闭添加弹窗
      handleClose() {
        this.$refs.active.resetFields();
      },
      // 关闭修改弹窗
      editClose(done) {
        this.editInfo = {};
        done();
      },
      // 删除选中项
      handleDel() {
        var ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        var params = {
          ids: ids.toString(),
        };
        this.$api.operate
          .bannerDelete(params)
          .then((res) => {
            this.$message.success(res);
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.getList();
          });
      },
      happenTimeFun(num){
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      return MM + '/' + d 
  },
      // 添加用户
      bannerSave() {
            this.$api.operate
              .bannerSave(this.active)
              .then((res) => {
                this.$message.success(res);
                this.dialogVisible = false;
                this.getList();
              })
              .catch((err) => {
                this.$message.error(err || "服务器错误，请稍后重试");
              })
              .finally(() => {
                this.buttongLoding = false;
              });
      },
      // 打开删除弹窗
      openDelete() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleDel();
          })
          .catch(() => {
            
          });
      },
     
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  ::v-deep .el-pagination{
  white-space: wrap !important;
  }
  </style>
  